import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { unsubscribeNews } from "../../services/AdminServices";
import FooterPanel from "../common/FooterPanel";
import MenuBar from "../common/MenuPanel";

const Unsubscribe = () => {
  const { email: paramEmail } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("confirm"); 
  // confirm | loading | success | error

  useEffect(() => {
    const resolvedEmail = paramEmail || queryParams.get("email");
    if (!resolvedEmail) {
      setStatus("error");
    } else {
      setEmail(resolvedEmail);
    }
  }, [paramEmail, location.search]);

  const handleConfirmUnsubscribe = async () => {
    try {
      setStatus("loading");
      const result = await unsubscribeNews(email);
      setStatus(result?.success ? "success" : "error");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <>
      <MenuBar />

      <div
        className="banner-image_sm"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
        }}
      >
        <div className="banner-heading text-center">
          <h1 className="text-white">Unsubscribe Newsletter</h1>
        </div>
      </div>

      <div style={{ padding: 40, textAlign: "center", maxWidth: 600, margin: "0 auto" }}>
        
        {status === "confirm" && (
          <>
            <h4>Are you sure you want to unsubscribe?</h4>
            <p style={{ color: "#555" }}>
              Email address: <strong>{email}</strong>
            </p>
            <p style={{ color: "#555" }}>
              You will stop receiving newsletters from Grace Anointing Ministries.
            </p>

            <div style={{ marginTop: 20 }}>
              <button
                className="btn btn-danger me-2"
                onClick={handleConfirmUnsubscribe}
              >
                Yes, Unsubscribe
              </button>

              <button
                className="btn btn-secondary"
                onClick={() => navigate("/")}
              >
                Cancel
              </button>
            </div>
          </>
        )}

        {status === "loading" && <p>⏳ Processing your request…</p>}

        {status === "success" && (
          <>
            <p>✅ You have been successfully unsubscribed.</p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => navigate("/")}
            >
              Go to Home
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <p>❌ Unable to process your request.</p>
            <p>Please try again later.</p>
          </>
        )}
      </div>

      <FooterPanel />
    </>
  );
};

export default Unsubscribe;
